<template>
  <div class="input-container" :style="{ margin: margin, height: height }">
    <label :class="{ labelObrigatorio: ((campoVazio && required) || !isTelValido) && showValidations }"> {{ label }}</label>
    <div v-if="temIcon" class="field">
      <p class="control has-icons-right">
        <input
          class="input"
          pattern="\([1-9]{2}\) (?:[2-8]|9[0-9])[0-9]{3,4}-[0-9]{4}"
          :id="id"
          type="tel"
          :required="required"
          :placeholder="placeholder"
          :value="modelValue"
          @input="$event => setValue($event)"
          :maxlength="15"
          ref="inputPhone"
          :mensagemCampoObrigatorio="mensagemCampoObrigatorio"
          :class="{ inValida: ((campoVazio && required) || !isTelValido) && showValidations}"
          @blur="validarTelefone"
        />
        <span class="icon is-small is-right">
          <i class="mdi" :class="classIcon"></i>
        </span>
      </p>
    </div>

    <input
      v-else
      class="input"
      type="tel"
      :placeholder="placeholder"
      :id="id"
      :maxlength="15"
      :required="required"
      @keyup="this.verificarSeInputEstaVazio(false)"
      pattern="\([1-9]{2}\) (?:[2-8]|9[0-9])[0-9]{3,4}-[0-9]{4}"
      :class="{ inValida: ((campoVazio && required) || !isTelValido) && showValidations}"
      :value="modelValue"
      :disabled="isDisabled"
      @input="$event => setValue($event)"
      ref="inputPhone"
      :mensagemCampoObrigatorio="mensagemCampoObrigatorio"
      @blur="validarTelefone"
    />

    <span v-if="tipLabel" class="tip-label is-size-7">{{ tipLabel }}</span>

    <div class="mensagemDeErro" v-if="showValidations">
      <span v-if="!isTelValido" class="campo-obrigatório">
        Insira um número de {{ label? label : 'Telefone' }} válido.
      </span>

      <span v-else-if="mensagemCampoObrigatorio && campoVazio && required" class="campo-obrigatório">
        {{ mensagemCampoObrigatorio }}
      </span>

      <span v-else-if="campoVazio && required" class="campo-obrigatório">
        {{ label? label : 'Telefone' }} é obrigatório.
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrfPhoneInput",
  props: {
    label: String,
    placeholder: String,
    margin: String,
    height: String,
    temIcon: Boolean,
    classIcon: String,
    modelValue: String,
    required: {
      type: Boolean,
      default: true
    },
    id: String,
    tipLabel: String,
    isDisabled: {
      type: Boolean,
      default: false
    },
    mensagemCampoObrigatorio: String
  },
  data() {
    return {
      campoVazio: false,
      isTelValido: false,
      showValidations: false
    };
  },
  methods: {
    async setValue(event) {
      const inputValue = event.target.value;
      const onlyNumbers = inputValue.replace(/\D/g, '')
      const valorFormatado = this.aplicarMascara(onlyNumbers)
      event.target.value = valorFormatado
      
      this.$emit('update:modelValue', valorFormatado)

      await this.$nextTick()
      this.isTelValido = !this.$refs.inputPhone.validity.patternMismatch
    },
    aplicarMascara(value) {
      if (!value) return '';
      value = value.replace(/\D/g,'')
      value = value.replace(/(\d{2})(\d)/,"($1) $2")
      value = value.replace(/(\d)(\d{4})$/,"$1-$2")
      return value
    },
    verificarSeInputEstaVazio(isInterno) {
      if (!isInterno) {
        this.showValidations = true
      }
      this.campoVazio = !this.modelValue || this.modelValue.trim() == "";
      this.verificarSeInputEValido()
      return this.campoVazio;
    },
    verificarSeInputEValido() {
      this.isTelValido = !this.$refs.inputPhone.validity.patternMismatch
      return this.isTelValido
    },
    
    limparValidacao() {
      this.campoVazio = false;
      this.showValidations = false;
    },
    
    limparInput() {
      this.modelValue == ''
    },
    
    validarTelefone(e) {
      let telefone = e.target.value;

      if(!telefone) return;

      this.verificarSeInputEstaVazio(false);
    }
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}
.inValida {
  border: 1px solid #a94442;
}
.mensagemDeErro {
  margin: 0 0 1% 0;
  color: #a94442;
  font-size: 12px;
}
.labelObrigatorio {
  color: #a94442;
}
.tip-label {
  color: #4a4a4a;
  vertical-align: top;
}
</style>
